import { ViewModel,ObservableArray } from "binder"
import { ComboBoxBaseViewModel } from "../comboBoxBase/comboBoxBase-viewModel";

export class MultiSelectComboBoxViewModel extends ComboBoxBaseViewModel{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ismultiple = true;
        this.placeholder = "";
    }
    public getTypeId(): string {
        return "VM-122BFE30-3A26-4EC3-9A2F-D8C3695071D7"
    }

    public set selecteditems(v: ObservableArray<ViewModel>) { 
        this.selectedItemsList = v;
    } 
    public get selecteditems(): ObservableArray<ViewModel> { 
        return this.selectedItemsList;
    }
    
}

